var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMurah(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.6327 24.2993C42 22.932 42 20.734 42 16.3333C42 11.9327 42 9.73467 40.6327 8.36733M40.6327 24.2993C39.2653 25.6667 37.0673 25.6667 32.6667 25.6667H23.3333C18.9327 25.6667 16.7347 25.6667 15.3673 24.2993M40.6327 8.36733C39.2653 7 37.0673 7 32.6667 7H23.3333C18.9327 7 16.7347 7 15.3673 8.36733M15.3673 8.36733C14 9.73467 14 11.9327 14 16.3333C14 20.734 14 22.932 15.3673 24.2993M30.3333 16.3333C30.3333 16.9522 30.0875 17.5457 29.6499 17.9832C29.2123 18.4208 28.6188 18.6667 28 18.6667C27.3812 18.6667 26.7877 18.4208 26.3501 17.9832C25.9125 17.5457 25.6667 16.9522 25.6667 16.3333C25.6667 15.7145 25.9125 15.121 26.3501 14.6834C26.7877 14.2458 27.3812 14 28 14C28.6188 14 29.2123 14.2458 29.6499 14.6834C30.0875 15.121 30.3333 15.7145 30.3333 16.3333Z",
    stroke: "url(#paint0_linear_40_31)",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14C40.1435 14 38.363 13.2625 37.0502 11.9497C35.7375 10.637 35 8.85652 35 7M42 18.6667C40.1435 18.6667 38.363 19.4042 37.0502 20.7169C35.7375 22.0297 35 23.8102 35 25.6667M14 14C15.8565 14 17.637 13.2625 18.9497 11.9497C20.2625 10.637 21 8.85652 21 7M14 18.6667C15.8565 18.6667 17.637 19.4042 18.9497 20.7169C20.2625 22.0297 21 23.8102 21 25.6667M11.6667 47.572H16.94C19.2967 47.572 21.6837 47.8193 23.9773 48.2907C28.0723 49.1319 32.2858 49.2252 36.414 48.566C38.4393 48.2393 40.4273 47.7377 42.2287 46.8697C43.8527 46.0833 45.843 44.9797 47.18 43.7407C48.5147 42.504 49.9053 40.481 50.89 38.899C51.7393 37.541 51.3287 35.8773 49.9893 34.867C49.2367 34.3196 48.33 34.0247 47.3993 34.0247C46.4687 34.0247 45.5619 34.3196 44.8093 34.867L40.593 38.052C38.9597 39.2887 37.1747 40.425 35.049 40.7633C34.7923 40.803 34.524 40.8403 34.244 40.873M34.244 40.873C34.1585 40.8829 34.0729 40.8922 33.9873 40.901M34.244 40.873C34.6175 40.772 34.9599 40.5795 35.2403 40.313C35.5919 40.0088 35.8791 39.6373 36.0847 39.2203C36.2904 38.8034 36.4105 38.3495 36.4379 37.8854C36.4653 37.4213 36.3995 36.9563 36.2443 36.5181C36.0891 36.0798 35.8477 35.6771 35.5343 35.3337C35.2303 34.9961 34.8761 34.7073 34.4843 34.4773C27.958 30.583 17.801 33.5487 11.6667 37.9003M34.244 40.873C34.1597 40.8914 34.0736 40.9007 33.9873 40.901M33.9873 40.901C32.5801 41.0424 31.1625 41.0455 29.7547 40.9103",
    stroke: "url(#paint1_linear_40_31)",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 36.1667C11.6667 34.2337 10.0997 32.6667 8.16666 32.6667C6.23367 32.6667 4.66666 34.2337 4.66666 36.1667V47.8334C4.66666 49.7663 6.23367 51.3334 8.16666 51.3334C10.0997 51.3334 11.6667 49.7663 11.6667 47.8334V36.1667Z",
    stroke: "url(#paint2_linear_40_31)",
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_40_31",
    x1: 4.35286,
    y1: 16.3334,
    x2: 89.4124,
    y2: 16.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A84448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A178"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_40_31",
    x1: -2,
    y1: 28,
    x2: 118.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A84448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A178"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_40_31",
    x1: 2.25488,
    y1: 42.0001,
    x2: 23.5198,
    y2: 42.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A84448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A178"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMurah);
export default __webpack_public_path__ + "static/media/Murah.649657d423e3448371ba3408f725f20a.svg";
export { ForwardRef as ReactComponent };